import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoYard = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

    const convertFeetToYard = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 3, 12.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const yardValue = feetValue / 3; // 1 yard = 3 feet
        setOutputValue(yardValue.toFixed(6)); // Limit output to 6 decimal places
    };








      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/yard-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to Yard Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to yard using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
       <TitleSection
                    icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                    title="Feet To Yard Converter"
                    subTitle="Effortlessly Convert Feet To Yard for Accurate Measurements"
                  />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToYard}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Yard Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>The Feet to Yards Converter is a useful tool for construction workers, landscapers, sports coaches, students, and anyone working with imperial measurements. It helps you convert feet (ft) into yards (yd) quickly and accurately, making it ideal for planning, field marking, or measuring large distances.</p>
      <p>Whether you're laying out a football field or buying fabric, this converter ensures clear and consistent measurements.</p>
      <h3>What Are Feet and Yards?</h3>
      <p><b>Feet (ft): </b>  A unit of length in the imperial system, commonly used in the U.S. for measuring height, room dimensions, or building specs. <br /> 1 foot = 12 inches</p>
      <p><b>Yards (yd): </b>A larger imperial unit used for measuring longer distances such as in sports, landscaping, or textiles. <br /> 1 yard = 3 feet</p>
      <h3>Why Convert Feet to Yards?</h3>
      <ul>
        <li><b>Larger Measurements:</b> Yards are more practical for measuring longer spans.</li>
        <li><b>Standard Use:</b> Yards are commonly used in sports fields, fencing, and construction zones.</li>
        <li><b>Clarity:</b> Converting feet to yards simplifies large values and enhances readability.</li>
      </ul>
      <h3>How to Use the Feet to Yards Converter</h3>
      <ol>
        <li><b>Enter Feet Value:</b> Type the number of feet.</li>
        <li><b>Click Convert:</b> Instantly view the value in yards.</li>
        <li><b>Use the Result:</b> Apply the conversion to your design, layout, or purchase.</li>
      </ol>
      <h3>Conversion Examples:</h3>
      <ul>
        <li>1 ft → 0.333 yd</li>
        <li>3 ft → 1 yd</li>
        <li>15 ft → 5 yd</li>
        <li>60 ft → 20 yd</li>
      </ul>
      <h3>Benefits of Using Feet to Yards Converter</h3>
      <ul>
        <li><b>Quick & Easy:</b> Instant conversions without manual math.</li>
        <li><b>Accurate:</b> Uses the exact 1 yard = 3 feet ratio.</li>
        <li><b>User-Friendly:</b> Designed for professionals and everyday users alike.</li>
      </ul>
      <h3>Who Is This Tool For?</h3>
      <ul>
        <li><b>Contractors & Builders:</b> For accurate layout and material planning.</li>
        <li><b>Coaches & Groundskeepers:</b> For field dimensions and markings.</li>
        <li><b>Sewing & Fabric Retailers:</b> Converting Fabric Lengths.</li>
        <li><b>Students & Teachers: </b> For learning and classroom use.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoYard;
